var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5;
var _react_refresh_temp_6;
_react_refresh_temp_6 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Listbox, Transition } from '@headlessui/react';
import { createSelector } from '@reduxjs/toolkit';
import { store, useAppDispatch, useAppSelector } from '../../store';
import { chatMessagesSelector } from '../../store/slices/chatMessagesSlice';
import Messages from './messages';
import { participantsSelector } from '../../store/slices/participantSlice';
import { updateSelectedChatOption, updateUnreadMsgFrom, } from '../../store/slices/roomSettingsSlice';
const selectedChatOptionSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.selectedChatOption);
$RefreshReg$(_react_refresh_temp_1, "selectedChatOptionSelector$createSelector");
const initiatePrivateChatSelector = createSelector(_react_refresh_temp_2 = (state) => state.roomSettings, (roomSettings) => roomSettings.initiatePrivateChat);
$RefreshReg$(_react_refresh_temp_2, "initiatePrivateChatSelector$createSelector");
const unreadMsgFromSelector = createSelector(_react_refresh_temp_3 = (state) => state.roomSettings, (roomSettings) => roomSettings.unreadMsgFrom);
$RefreshReg$(_react_refresh_temp_3, "unreadMsgFromSelector$createSelector");
const ChatTabs = () => {
    _react_refresh_temp_6();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const initiatePrivateChat = useAppSelector(initiatePrivateChatSelector);
    const chatMessages = useAppSelector(chatMessagesSelector.selectAll);
    const [privateChatUsers, setPrivateChatUsers] = useState(new Map());
    const currentUser = store.getState().session.currentUser;
    const unreadMsgFrom = useAppSelector(unreadMsgFromSelector);
    const selectedChatOption = useAppSelector(selectedChatOptionSelector);
    const [chatOptions, setChatOptions] = useState([
        {
            id: 'public',
            title: t('left-panel.public-chat'),
        },
    ]);
    const [selectedTitle, setSelectedTitle] = useState(t('left-panel.public-chat').toString());
    useEffect(() => {
        if (initiatePrivateChat.userId !== '') {
            privateChatUsers.set(initiatePrivateChat.userId, initiatePrivateChat.name);
            setPrivateChatUsers(new Map(privateChatUsers));
        }
        chatMessages.forEach((m) => {
            var _a;
            if (m.isPrivate) {
                if (m.from.userId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId)) {
                    if (!privateChatUsers.has(m.from.userId)) {
                        privateChatUsers.set(m.from.userId, (_a = m.from.name) !== null && _a !== void 0 ? _a : '');
                        setPrivateChatUsers(new Map(privateChatUsers));
                    }
                }
                else if (m.from.userId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) &&
                    m.to &&
                    m.to !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId)) {
                    if (!privateChatUsers.has(m.to)) {
                        const user = participantsSelector.selectById(store.getState(), m.to);
                        if (user) {
                            privateChatUsers.set(user.userId, user.name);
                            setPrivateChatUsers(new Map(privateChatUsers));
                        }
                    }
                }
            }
        });
    }, [initiatePrivateChat, chatMessages]);
    useEffect(() => {
        const options = [
            {
                id: 'public',
                title: t('left-panel.public-chat'),
            },
        ];
        privateChatUsers.forEach((u, id) => {
            options.push({
                id,
                title: u,
            });
        });
        setChatOptions(options);
    }, [privateChatUsers, t]);
    useEffect(() => {
        const tmp = chatOptions.filter((o) => o.id === selectedChatOption);
        if (tmp.length) {
            setSelectedTitle(tmp[0].title);
        }
    }, [selectedChatOption, chatOptions]);
    const onChange = (id) => {
        dispatch(updateSelectedChatOption(id));
        dispatch(updateUnreadMsgFrom({
            task: 'DEL',
            id: id,
        }));
    };
    return (_jsxs("div", { className: "h-full", children: [_jsx(Listbox, { value: selectedChatOption, onChange: onChange, children: _jsxs("div", { className: "relative h-10 z-10", children: [_jsxs(Listbox.Button, { className: "flex items-center justify-between py-2 text-sm text-black dark:text-darkText font-bold leading-5 border-b-4 border-solid transition ease-in shrink-0 border-primaryColor w-full", children: [_jsx("span", { className: "block truncate pl-4 md:pl-6", children: selectedTitle }), _jsxs("span", { className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2", children: [unreadMsgFrom.length ? (_jsx("span", { className: "shake pr-1 -mb-1", children: _jsx("i", { className: "pnm-chat shake" }) })) : null, _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-5 w-5", viewBox: "0 0 20 20", fill: "currentColor", children: _jsx("path", { fillRule: "evenodd", d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z", clipRule: "evenodd" }) })] })] }), _jsx(Transition, { as: Fragment, leave: "transition ease-in duration-100", leaveFrom: "opacity-100 z-90", leaveTo: "opacity-0", children: _jsx(Listbox.Options, { className: "absolute max-h-60 w-full overflow-auto rounded-md bg-white dark:bg-darkPrimary py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: chatOptions.map((option) => (_jsx(Listbox.Option, { className: ({ active }) => `relative cursor-pointer select-none py-2 pl-10 pr-4 ${active
                                        ? 'bg-primaryColor text-white'
                                        : 'text-gray-900 dark:text-darkText'}`, value: option.id, children: ({ selected }) => (_jsxs(_Fragment, { children: [_jsxs("span", { className: `flex truncate items-center justify-between ${selected ? 'font-medium' : 'font-normal'}`, children: [option.title, unreadMsgFrom.filter((id) => id === option.id)
                                                        .length ? (_jsx("span", { className: "shake pr-1", children: _jsx("i", { className: "pnm-chat shake" }) })) : null] }), selected ? (_jsx("span", { className: "absolute inset-y-0 left-0 flex items-center pl-3 text-secondaryColor", children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-5 w-5", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: 2, children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M5 13l4 4L19 7" }) }) })) : null] })) }, option.id))) }) })] }) }), _jsx("div", { className: "h-[calc(100%-40px)]", children: _jsx(Messages, { userId: selectedChatOption }) })] }));
};
_react_refresh_temp_4 = ChatTabs;
$RefreshReg$(_react_refresh_temp_4, "ChatTabs");
_react_refresh_temp_6(ChatTabs, "TlusEvwsj/Bvtqirvn8dqK2tbN4=", false, () => [useTranslation, useAppDispatch, useAppSelector, useAppSelector, useAppSelector, useAppSelector]);
export default _react_refresh_temp_5 = React.memo(ChatTabs);
$RefreshReg$(_react_refresh_temp_5, "%default%");
